import { RSAA } from 'redux-api-middleware';

export default store => next => action => {
  const callApi = action[RSAA]

  // Check if this action is a redux-api-middleware action.
  if (callApi) {
    // Inject the Authorization header from localStorage.
    callApi.headers = {
      ...callApi.headers,
      storeid: store.getState().store.data.storeId
    }
  }

  // Pass the FSA to the next action.
  return next(action)

}